export default {
  signature: {
    title: 'Sign data',
    signatureDate: 'Sign date',
    issuer: 'Certificate issuer',
    organization: 'Organization',
    serialNumber: 'Serial Number',
    validity: 'Validity',
    to: ' to '
  }
}
